import React from 'react'
import Main from '../../Main'

const content = ( 
  <div className="island">
    <h1> FAQ </h1>
    <div className="field field-name-body field-type-text-with-summary field-label-hidden">
      <div className="field-items">
        <div className="field-item even">
          <p><strong>How are children chosen for sponsorship?</strong ></p>

          <p>World Vision works with communities in the Philippines where there are poorest of the poor.We partner with local staff and families to identify areas of greatest need and then the community selects children from those areas for sponsorship.We then ask the children’ s families if they want to be part of the sponsorship program and explain how it works.</p>
  
          <p><strong>Will I be able to choose a child to sponsor?</strong></p>
          <p>A child will be automatically assigned to you upon signing up as a sponsor. </p>
          <p><strong>How long will my sponsorship last?</strong></p>
          <p>Your sponsorship may last from several months up to several years depending on your circumstances and that of your sponsored child</p> 
          <p><strong>Why is my sponsored child being replaced? </strong></p>
        <p>Sponsorship is a long-term commitment. However, due to unforeseen circumstances, the child you choose to support for a long period of time can be replaced and sponsorship may end for any of the following reasons:</p>
        
        <p><i>Sponsored child’s family is economically stable-</i> In this case, sponsored child may finish school, his/ her family begins to earn an income, and they are able to support themselves. </p>
        <p>
        <i>The Community has “graduated”- </i> When the goal of making the community’s capacity and development phase become sustainable, that’s when we move out to another community to help children and families break the cycle of poverty.
        </p>
        <p>
        <i>Family moved to a different community-</i> This happens when a child’s family move out of the community into an area where World Vision sponsorship is not available, a child must leave then the program.
        </p>
        <p>
        When a child is no longer available or when a project comes to an end, we will let you know and you 
        will be invited to help transform another child’s life.
        </p>
          <p><strong>How can I give my donation to my sponsored child?</strong> You have the following giving options to choose from:</p>
          <ol>
            <li>
              <strong>BANK DEPOSIT</strong>
              <p>Deposit Online– Give your donations by enrolling World Vision in the Bills Payment section & amp; your unique World Vision Partner ID with just a few clicks : BPI Express Online - <a href="http://www.bpiexpressonline.com/"
                            target="_blank" rel="noopener noreferrer">http://www.bpiexpressonline.com/</a></p>
              <p>Bancnet Online - <a href="http://www.bancnetonline.com/" target="_blank" rel="noopener noreferrer"> http://www.bancnetonline.com/</a></p>
              <p>Deposit over the counter– Personally go to a bank & amp; deposit your donation with the following details: </p> 
              <p>Account Name: World Vision Development Foundation</p> 

              <ul> 
                <li>Bank of the Philippine Islands Account Number: 4251 - 0024 - 15 </li> 
                <li>Banco de Oro Account Number: 000 - 2700 - 4341 - 1 </li>
                <li>PS Bank Account Number: 038 - 33200013 - 8 </li>
                <li>Metrobank Account Number: 060 - 7060 - 5186 - 41 </li>
              </ul>
  
              <p>Please send a copy of your confirmation email (for online bills payment) or a copy of your deposit slip (with your name written on it) to <a href="mailto:wv_phil@wvi.org">wv_phil@wvi.org</a></p>
            </li>
            <li>
              <strong>CREDIT CARD</strong>
              <p>Upon signing up at a sponsor at <a href="http://www.worldvision.org.ph/sponsor-child" target="_blank" rel="noopener noreferrer">https://www.worldvision.org.ph/sponsor-child</a>, you will be redirected to PesoPay. If you’re residing outside the Philippines, you can give by remitting your donation to any of the bank accounts of World Vision: Account Name: World Vision Development Foundation</p>
              <ul>
                <li>Bank of the Philippine Islands Account Number: 4251 - 0024 - 15 </li>
                <li>Banco de Oro Account Number: 000 - 2700 - 4341 - 1 </li>
                <li>PS Bank Account Number: 038 - 33200013 - 8 </li>
                <li>Metrobank Account Number: 060 - 7060 - 5186 - 41 </li>
              </ul>
            </li>
          </ol>
          <p><strong>How do I know that there is a real child and my contribution gets to him? </strong></p>
          <p>You will receive the child’ s picture folder upon giving your first donation.You may also exchange correspondences with him or her by responding to his first letter.</p>
          <p>You will see the progress of your sponsored child through the annual progress reports through mail.It contains the child’ s latest photo, average grade, community updates and message from him or her.You may also plan to visit him / her.Just contact us one month before your proposed schedule for arrangement.</p>
          <p><strong>How does World Vision Safeguard Children and Sponsors? </strong></p>
          <p>It is at the heart of World Vision to create an environment where children and adults can live life to the fullest. With our <a href="https://www.worldvision.org.ph/wp-content/uploads/2021/03/Annex-2-WVI-PARTNERSHIP-MANAGEMENT-POLICY.pdf" rel="noopener noreferrer">Child and Adult Safeguarding Policy</a>, we are committed to safeguard and protect vulnerable children and adults, doing no form of harm and ensuring zero tolerance to sexual exploitation and abuse. 
          </p>
          <p>
We undertake prevention and safeguarding trainings to provide basic guidelines to ensure the safety, dignity and privacy of both children and sponsors, requiring all staff and volunteers to agree to observe policies and understand the disciplinary actions for any policy violations. 
</p><p>
Included in the policy also are screening measures such as behavioural-based interview questions, identity and background Checks which are used when hiring for positions that involves working directly with children.  
</p><p>
Strict safeguards are also in place to protect children during visits. All visits are organized and visitors are accompanied by World Vision employees. Protocols are also in place to ensure that photos and video recordings of sponsored children are used appropriately, and letters are opened and carefully checked.  
</p><p>
World Vision prioritizes protection of vulnerable children, sponsors, communities and its own staffs.
</p>
<p>
Read the full text <a href="https://www.worldvision.org.ph/wp-content/uploads/2021/03/Annex-2-WVI-PARTNERSHIP-MANAGEMENT-POLICY.pdf" target="_blank" rel="noopener noreferrer">Child and Adult Safeguarding Policy.</a>
</p>
          <p><strong>How do I contact my sponsored child?</strong></p>
          <p>You are encouraged to connect with your sponsored child.Sponsored children love to receive letters and cards from their sponsors and it can be a great source of encouragement for them.</p>
          <p>Here are two ways to correspond and build a connection with your sponsored child: </p>
          <ol>
            <li><strong>Snail Mail.</strong> Send your letter to our office, 389 Quezon Avenue corner West 6th St. West Triangle, Quezon City 1104</li >
            <li><strong>Email.</strong> You can also send your letter to your sponsored child at <a href="http://www.worldvision.org.ph/send-letter-to-your-sponsored-child" target="_blank" rel="noopener noreferrer">http://www.worldvision.org.ph/send-letter-to-your-sponsored-child</a>.
            </li> 
          </ol>
          
          <p><strong>What if I need to cancel? Will I still be charged? Is it a contract? </strong></p>
          
          <p>We encourage sponsors to view sponsorship as a long - term commitment.But a sponsor can cancel at any time, for any reason.</p>
          <p>We understand that sometimes your budget gets a little tight, so let us know when there is a problem.If you are unable to make regular payments either temporarily or permanently, we can assist you with a range of options. </p> 

          <p><strong>I'd like to be a child ambassador, where could I sign up?</strong></p>
          <p>
            <a href="ambassador">Click here to signup as a child ambassador</a>
          </p>
          
        </div>

       

      </div> 
    </div>
  </div >
)

const Faq = () => ( 
  <Main>
    {content}
  </Main>
)

export default Faq